<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.tags' | translate}}"
  [itemsData]="tags"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'tags'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.usageCount' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-tag>

    <tr>
      <td>
        &nbsp;{{ tag.id }}
      </td>
      <td>
        <span [style.backgroundColor]="'#' + tag.color" class="dot mr-1"></span>
        &nbsp;<span [innerHTML]="tag.name |truncate: 60"></span>
      </td>
      <td>
        &nbsp;{{ tag.description }}
      </td>
      <td>
        {{ tag.associationCount }}
      </td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="tag.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

 Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
